import Vue from 'vue';
import { mapState } from 'vuex';
import { getStarsHTML } from 'utils/general';
import store from 'store';
import { i18n } from 'lib/i18n.js';
import bus from 'lib/bus';

export default (el) =>
  new Vue({
    components: {
      'product-card': () => import('../product-card/product-card.vue'),
      'product-price': () => import('../product-price/product-price.vue'),
    },
    el,
    store,
    i18n,
    data() {
      return { ...el.dataset };
    },
    computed: {
      ...mapState('global'),
      stars() {
        if (!this.reviewsAverage) return '';
        return getStarsHTML(this.reviewsAverage);
      },
      rating() {
        if (!this.reviewsAverage) return '';
        return this.reviewsAverage;
      },
      readReviewsLink() {
        if (!this.reviewsCount) return '';
        return `View ${this.reviewsCount} Review${
          this.reviewsCount > 1 ? 's' : ''
        }`;
      },
    },
    methods: {
      openReviews() {
        bus.$emit('open-reviews-accordion');
      },
    },
  });
